module.exports = __webpack_public_path__ + "img/values1.867a3ada.jpg";